<template>
    <div class="simple__block">
        <h3 class="h5">{{ get_translation_constant('text_transaction_history') }}</h3>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="form__col">
                    <multiselect v-model="transaction_type_id"
                                 :multiple="false"
                                 :placeholder="get_translation_constant('text_all_transactions')"
                                 :options="transactionsTypes"
                                 label="title"
                                 selectLabel=""
                                 deselectLabel=""
                                 :optionHeight="48"
                                 :showPointer="true"
                                 :searchable="false"
                    >
                        <template></template>
                    </multiselect>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form__col">
                    <input v-model="search" class="form__control form__search" id="search" name="search" type="text"
                           :placeholder="get_translation_constant('text_search')">
                </div>
            </div>
        </div>
        <table class="table table__transaction">
            <tbody>
            <transaction-item v-for="(transaction, index) in filteredTransactions "
                              :transaction="transaction"
                              :key="index"
                              :currencies="currencies"
                              :paymentoperations="paymentoperations"
                              :paymentmethods="paymentmethods"
                              :transactionsTypes ="transactionsTypes"
            ></transaction-item>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "Transactions",
    props: {
        translations: {
            type: [Object, Array]
        },
        transactions: {
            type: [Object, Array]
        },
        currencies: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        paymentoperations: {
            type: [Object, Array]
        },
        paymentmethods: {
            type: [Object, Array]
        },
    },
    data() {
        return {
            transaction_type_id: {
                id: 0
            },
            search: '',
            transactionsTypes: [],
        }
    },
    methods: {
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        formatTransactionsToSearch() {
            this.transactionsTypes.push({
                id:   0,
                title : this.get_translation_constant('text_all_transactions'),
                class: ''
            })
            for (let paymentOperationKey in this.paymentoperations) {
                for (let paymentTypeKey in this.paymentmethods) {

                    if (this.paymentmethods[paymentTypeKey].payment_type.title === 'balance') {

                        if (paymentOperationKey === 'Extract') {
                                this.transactionsTypes.push({
                                    id:   [this.paymentoperations[paymentOperationKey], this.paymentmethods[paymentTypeKey].payment_type.id, 0 ].join('.'),
                                    title : this.get_translation_constant('text_withdraw_from_the_balance'),
                                    class: 'extract account'
                                })
                            this.transactionsTypes.push({
                                id:   [this.paymentoperations[paymentOperationKey], this.paymentmethods[paymentTypeKey].payment_type.id, 1 ].join('.'),
                                title : this.get_translation_constant('text_payment_by_balance'),
                                class: 'extract account'
                            })
                        }

                        if (paymentOperationKey === 'Refill') {

                            this.transactionsTypes.push({
                                id:  [this.paymentoperations[paymentOperationKey], this.paymentmethods[paymentTypeKey].payment_type.id, 0 ].join('.'),
                                title : this.get_translation_constant('text_replenishment_of_balance'),
                                class: 'refill account'
                            })
                        }

                    }

                    if (this.paymentmethods[paymentTypeKey].payment_type.title === 'bonus') {
                        if (paymentOperationKey === 'Extract') {
                            this.transactionsTypes.push({
                                id:   [this.paymentoperations[paymentOperationKey], this.paymentmethods[paymentTypeKey].payment_type.id, 0 ].join('.'),
                                title : this.get_translation_constant('text_withdraw_from_the_bonus'),
                                class: 'extract bonus'
                            })
                            this.transactionsTypes.push({
                                id:   [this.paymentoperations[paymentOperationKey], this.paymentmethods[paymentTypeKey].payment_type.id, 1 ].join('.'),
                                title : this.get_translation_constant('text_payment_by_bonus'),
                                class: 'extract bonus'
                            })
                        }

                        if (paymentOperationKey === 'Refill') {
                            this.transactionsTypes.push({
                                id:  [this.paymentoperations[paymentOperationKey], this.paymentmethods[paymentTypeKey].payment_type.id, 0 ].join('.'),
                                title : this.get_translation_constant('text_replenishment_of_bonuses'),
                                class: 'refill bonus'
                            })
                        }
                    }
                }
            }
        }
    },
    computed: {
        filteredTransactions() {

            let list = this.transactions.map((item)=>{
                let hasParcel = 0;
                if (item.parcel_id !==null){
                    hasParcel = 1;
                }
                item.type_id = [item.payment_operation_type_id, item.payment_method_type_id, hasParcel].join('.')
                return item;
            });

            if (this.search !== '') {
                list = list.filter((item) => {
                    return (item['id'].toString().indexOf(this.search) !== -1) ||
                        (item['amount'].toString().indexOf(this.search) !== -1) ||
                        (item['created_at'].indexOf(this.search) !== -1) ||
                        (this.transactionsTypes.filter((type) => {
                            return type['id'] === item['type_id']
                        })[0]['title'].indexOf(this.search) !== -1)
                })
            }
            if (this.transaction_type_id.id === 0) {
                return list
            }
            return list.filter((item) => {
                return item.type_id === this.transaction_type_id.id
            })
        }
    },
    mounted() {

    },
    created() {

        this.formatTransactionsToSearch()

    }
}
</script>

<style scoped>

</style>
